import {
    AUTO_REDUCE,
    REVIEW_MANUALLY,
    BUILD_ORDER,
    CART_CONFIRMATION_MODAL,
    DELETE_DELIVERY,
    DUPLICATE_LOCATIONS_MODAL,
    EDIT_DELIVERY_MODAL,
    MANAGE_DELIVERIES_MODAL,
    VIEW_INVENTORY,
    WORKING_ORDER_UPDATE_ACTION,
    WORKING_ORDER_UPDATE_TYPE,
    IFRAME_REDUX_ACTION,
    GRID_VIEW_NOTIFICATION,
} from "constants/cart";
import { ILineItem, ILineItemSize } from "constants/order-types";
import { GridBuffer } from "constants/sizingView";
import _ from "lodash";
import { IProduct } from "records/item/item";
import { ILocation } from "types/cart/shipment-review";
import { IGridItem } from "helpers/legacy-cart/line-items/items-conversion-helper";
import { mapId } from "containers/legacy-cart/helpers";
import { ICartConfirmation } from "reducers/cart-confirmation";
import { INotification } from "reducers/cart-notifications";
import { CART_NOTIFICATIONS } from "constants/action-types";

type ISizeUpdate = Partial<ILineItemSize> & { size: string; size_group: string };

export interface IWorkingUpdate {
    type: WORKING_ORDER_UPDATE_TYPE;
    pivot: string;
    item?: Partial<CastProp<ILineItem, "sizes", ISizeUpdate[]>>;
    size?: ISizeUpdate;
}
interface IItemRemove {
    type: WORKING_ORDER_UPDATE_TYPE.LINE_ITEM_REMOVE;
    pivot: string | string[];
}
interface IProductRemove {
    type: WORKING_ORDER_UPDATE_TYPE.PRODUCT_REMOVE;
    product: string | string[];
}

type IUpdateAction = IWorkingUpdate | IItemRemove | IProductRemove;

export const updateWorkingOrder = (payload: IUpdateAction | IUpdateAction[]) => ({
    action: WORKING_ORDER_UPDATE_ACTION,
    payload,
});

export const updateProductsForInsights = (productId: string) => ({
    action: "remove-product-for-insights",
    productId,
});

export const updateSize = (id: string, size: IWorkingUpdate["size"]): IWorkingUpdate => ({
    type: WORKING_ORDER_UPDATE_TYPE.SIZE_UPDATE,
    pivot: mapId(id),
    size,
});

export const addSize = (id: string, size: IWorkingUpdate["size"], item?: IWorkingUpdate["item"]): IWorkingUpdate => ({
    type: WORKING_ORDER_UPDATE_TYPE.SIZE_ADD,
    pivot: mapId(id),
    item,
    size,
});

export const updateLineItem = (id: string, item: IWorkingUpdate["item"]): IWorkingUpdate => ({
    type: WORKING_ORDER_UPDATE_TYPE.LINE_ITEM_UPDATE,
    pivot: mapId(id),
    item,
});

export const createLineItem = (id: string, item: IWorkingUpdate["item"]): IWorkingUpdate => ({
    type: WORKING_ORDER_UPDATE_TYPE.LINE_ITEM_CREATE,
    pivot: mapId(id),
    item,
});

export const addLineItem = (id: string, item: IWorkingUpdate["item"]): IWorkingUpdate => ({
    type: WORKING_ORDER_UPDATE_TYPE.LINE_ITEM_ADD,
    pivot: mapId(id),
    item,
});

export const removeLineItems = (ids: string[] | string): IItemRemove => ({
    type: WORKING_ORDER_UPDATE_TYPE.LINE_ITEM_REMOVE,
    pivot: _.map(_.castArray(ids), mapId),
});

export const handleBuildOrderOpen = () => ({ action: BUILD_ORDER });

export const handleEditDelivery = (item: Partial<ILineItem>) => ({
    action: EDIT_DELIVERY_MODAL,
    payload: item,
});

export const handleManageDeliveries = (item: Partial<ILineItem>) => ({
    action: MANAGE_DELIVERIES_MODAL,
    payload: item,
});

export const handleDeleteDelivery = (id: string) => ({
    action: DELETE_DELIVERY,
    payload: { id },
});

export const viewInventory = (product: Partial<IProduct>, options: { availableWarehouses: string[] }) => ({
    action: VIEW_INVENTORY,
    payload: { product, ...options },
});

export const handleDuplicateLocationsModal = (locations: ILocation[], buffer: GridBuffer, data: IGridItem[]) => ({
    action: DUPLICATE_LOCATIONS_MODAL,
    payload: { locations, buffer, data },
});

export const removeProducts = (products: string[] | string): IProductRemove => ({
    type: WORKING_ORDER_UPDATE_TYPE.PRODUCT_REMOVE,
    product: _.castArray(products),
});

export const showCartConfirmation = (confirmation: ICartConfirmation) => ({
    action: CART_CONFIRMATION_MODAL,
    confirmation,
});

export const dismissNotification = (notification: INotification) => ({
    action: GRID_VIEW_NOTIFICATION.DISMISS,
    payload: notification.id,
});

export const removeNotifications = (notifications: INotification[] | INotification) => ({
    action: GRID_VIEW_NOTIFICATION.REMOVE,
    payload: _.map(_.castArray(notifications), "id"),
});

export const syncCartNotifications = () => ({
    action: IFRAME_REDUX_ACTION,
    payload: {
        type: CART_NOTIFICATIONS.SYNC,
    },
});

export const autoReduce = () => ({ action: AUTO_REDUCE });
export const reviewManually = () => ({ action: REVIEW_MANUALLY });
